import React from 'react'
import Module from '../../../../layout/Module'
import DataGrid from '../../../../table/DataGrid'
import { useSelector } from 'react-redux'
import TextLog from '../../../../text/TextLog'
import IconTooltipButton from '../../../../button/IconTooltipButton'
import { useNavigate } from 'react-router-dom'
import useCurriculums from '../../../../../hooks/curriculum/useCurriculum'

const List = ({ onModal }) => {
  const navigate = useNavigate()
  const columnsTable = useSelector((state) => state?.datatable?.curriculum?.columnsTable || [])
  const list = useSelector((state) => state?.curriculum?.curriculums || [])
  const { isLoadingList } = useCurriculums()
  const permissions = useSelector((state) => state?.session?.permissions?.curriculum || {})

  return (
    <Module.BodyFullContainer>
      <DataGrid
        id='curriculum'
        rows={list?.map((row, index) => ({
          ...row,
          index: index + 1,
          log: <TextLog updatedAt={row.updatedAt} updatedBy={row.updatedBy} />,
          actions: 
          <div className='flex items-center gap-1 items-center justify-center'>
            <IconTooltipButton
              id={`edit-${row._id}`}
              disabled={isLoadingList}
              title='View'
              icon='eye'
              onClick={() => navigate(`/dashboard/curriculum/${row._id}`)}
            />
            { permissions?.deleted && (
              <IconTooltipButton
                id={`delete-${row._id}`}
                disabled={isLoadingList}
                title='Delete'
                icon='trash-alt'
                onClick={() => onModal({
                  type: 'delete',
                  form: row
                })}
              />
            )
            }
          </div>
        })) || []}
        loading={isLoadingList}
        rowsPerPage={list?.length || 5}
        showSetting={false}
        columns={[
          { label: '#', key: 'index', align: 'center', width: 10, show: true, hide: false  },
          ...columnsTable,
          { label: 'Log', key: 'log', align: 'center', className: "text-center box-center", width: 120, show: true, hide: false },
          { label: 'Actions', key: 'actions', align: 'center', width: 50, show: true, hide: false  }
        ]}
        nameModule='curriculum'
        labelNoRows="You don't have any curriculum yet"
      />
    </Module.BodyFullContainer>
  )
}

export default List